import { React, useState } from "react";
import { Link } from "react-router-dom";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

function Header() {
  const [darkMode, setDarkMode] = useState(true);
  const [toggle, setToggle] = useState(false);
  const HTML = document.querySelector("html");
  // const to = document.querySelector(".to");
  let ib = !toggle ? <MenuIcon style={{color:darkMode ? "white" : "black"}} /> : <CloseIcon style={{color:darkMode ? "white" : "black"}} />;
  
  
  // console.log(links);
  function handleClick() {
    if (!darkMode) {
      document.body.style.backgroundColor = "#141619";
      HTML.classList.add("dark");
    }
    if (darkMode) {
      document.body.style.backgroundColor = "aliceblue";
      HTML.classList.remove("dark");
    }

    setDarkMode((prevValue) => {
      return !prevValue;
    });
  }
  function onToggle() {
    const Nav = document.querySelector(".Nav");
    if(Nav.classList.contains("hidden")){
        Nav.classList.remove("hidden");
    }
    else{
        Nav.classList.add("hidden");
    }
    setToggle((prevValue) => {
      return !prevValue;
    });
  }
  return (
    <header className="z-30 flex fixed w-full justify-center mb-96 md:mb-16 lg:mb-12 backdrop-filter backdrop-blur-lg bg-opacity-30 top-0">
      <div className="nav inline-block lg:flex justify-between p-7 shadow-xl bg-gradient-to-br from-slate-950 to-[#141619] rounded-2xl lg:rounded-full lg:w-4/5 w-full flex-wrap ">
        <div className="flex justify-between">
          <a href="./" className="flex title items-center ml-1 md:ml-3 lg:ml-10 dark:text-white/90 text-black/90 text-2xl sm:text-3xl md:text-4xl">
            SahilDhoot
          </a>
          <IconButton onClick={onToggle} className="flex lg:invisible sm:mr-16">
            {ib}
          </IconButton>
        </div>
        {/* {toggle ? <div></div> : <IconButton onClick={onToggle} className="to visible lg:invisible "><CloseIcon /></IconButton>} */}
        {/* {toggle ? (
          <div></div>
        ) : ( */}
        <div className="hidden lg:flex justify-center Nav">
          <ul className="links flex gap-y-1 gap-x-10 lg:gap-x-6 items-center mr-3 lg:mr-10 flex-col lg:flex-row mt-3 md:mt-0">
              <li className="link dark:text-white/80 text-black/80 text-2xl hover:text-3xl hover:underline hover:underline-offset-14 hover:transition-all decoration-sky-500">
                <Link to="/">Home</Link>
              </li>
              <li className="link dark:text-white/80 text-black/80 text-2xl hover:text-3xl hover:underline hover:underline-offset-14 hover:transition-all decoration-sky-500 ">
                <Link to="/about">About</Link>
              </li>
              <li className="link dark:text-white/80 text-black/80 text-2xl hover:text-3xl hover:underline hover:underline-offset-14 hover:transition-all decoration-sky-500 ">
                <Link to="/contact">Contact</Link>
              </li>
              <IconButton onClick={handleClick} className="transition-all ease-linear duration-200">
                {darkMode ? <LightModeOutlinedIcon style={{color:"white"}} /> : <DarkModeOutlinedIcon style={{color:"black"}} />}
              </IconButton>
            </ul>
        </div>
          
        {/* )} */}
        {/* <IconButton onClick={onToggle} className="to visible lg:invisible ">{ib}</IconButton> */}
      </div>
    </header>
  );
}

export default Header;
